/**
 * Utility functions for authentication
 */
import { toast } from 'react-toastify';

/**
 * Logs out the user by clearing localStorage and redirecting to login
 * @param {string} message - Optional message to show in toast notification
 */
export const logout = (message = "Session expired. Please login again.") => {
  // Clear all authentication-related data
  localStorage.removeItem('token');
  localStorage.removeItem('userDetail');
  localStorage.removeItem('frontend_version');
  
  // Show notification
  toast.error(message);
  
  // Redirect to login page
  if (typeof window !== 'undefined') {
    window.location.href = '/resumate/login';
  }
};

/**
 * Checks if user is authenticated
 * @returns {boolean} - True if user is authenticated, false otherwise
 */
export const isAuthenticated = () => {
  try {
    const token = localStorage.getItem('token');
    const userDetail = localStorage.getItem('userDetail');
    
    if (!token || !userDetail) {
      return false;
    }
    
    const parsedToken = JSON.parse(token);
    const parsedUserDetail = JSON.parse(userDetail);
    
    return !!(parsedToken && parsedUserDetail && 
              parsedToken !== 'null' && parsedToken !== 'undefined' &&
              parsedUserDetail !== 'null' && parsedUserDetail !== 'undefined');
  } catch (error) {
    console.error('Error checking authentication:', error);
    return false;
  }
};

/**
 * Gets user details from localStorage
 * @returns {object|null} - User details object or null if not found
 */
export const getUserDetails = () => {
  try {
    const userData = localStorage.getItem('userDetail');
    if (userData) {
      return JSON.parse(userData);
    }
    return null;
  } catch (error) {
    console.error('Error parsing user details:', error);
    return null;
  }
};

/**
 * Gets token from localStorage
 * @returns {string|null} - Token string or null if not found
 */
export const getToken = () => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      return JSON.parse(token);
    }
    return null;
  } catch (error) {
    console.error('Error parsing token:', error);
    return null;
  }
}; 